import { ApprovalCompany } from '@/lib/api/financial/billing-approval-api'
import { useAuth } from '@/store/hooks'
import { MdStore } from 'react-icons/md'

interface CompanyBadgeProps {
    company?: ApprovalCompany | null
}

/**
 * Filial dona da solicitação, no cabeçalho do card.
 *
 * As três filas passaram a ser da ORGANIZAÇÃO — antes cada uma listava só a filial
 * da sessão, e decidir algo de outra unidade respondia "não encontrada". Com todas
 * as unidades na mesma tela, o operador precisa saber de qual delas é cada linha:
 * duas contas do mesmo fornecedor, mesmo valor e mesmo vencimento são exatamente o
 * caso em que aprovar a errada custa dinheiro.
 *
 * Só aparece quando a filial é **diferente** da que o usuário está usando — no dia
 * a dia de uma organização com uma única unidade, o selo seria ruído em todas as
 * linhas.
 */
export default function CompanyBadge({ company }: CompanyBadgeProps) {
    const { user } = useAuth()
    if (!company || company.id === user?.companyId) return null

    return (
        <>
            <span>·</span>
            <span
                className="badge badge-xs badge-ghost gap-1 whitespace-nowrap"
                title="Solicitação de outra unidade da organização"
            >
                <MdStore className="text-xs" />
                {company.tradingName || company.name}
            </span>
        </>
    )
}
